import Home from './renderers/home';
import Page from './renderers/page';
import Contact from './renderers/contact';
import Nav from './components/nav';
import Slider from './components/slider';
import Animations from './components/animations';

document.addEventListener('DOMContentLoaded', () => {
	// DOM loaded
    const classes = document.body.classList;
    switch ( true ) {
		case classes.contains('home'):
			new Home();
		break;

		case classes.contains('page-template-contact'):
			new Contact();
		break;

		default:
			new Page();
	}

    new Nav();

    Slider.init();
    Animations.init();
});